import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { LibraryItemDTO } from '../types';

const url = `${PREFIX_URL}/library/:libraryItemId`;

export type GetLibraryItemResponse = {
  status: boolean;
  data: LibraryItemDTO[];
};

export type GetLibraryItemDTO = {
  libraryItemId: number;
  showError?: boolean;
};

export type GetLibraryItemParams = {
  page: number;
  inTrash?: boolean;
  limit: number;
};

export const getLibraryItemQueryKey = {
  list: ['getLibraryItem'] as const,
};

export const getLibraryItem = ({
  libraryItemId,
  showError = true,
}: GetLibraryItemDTO): Promise<GetLibraryItemResponse> => {
  const URL = generateRoutePath(url, { libraryItemId });

  return axios.get(URL, { showError });
};
type QueryFnType = typeof getLibraryItem;

type UseGetLibraryItemOptions = {
  libraryItemId: number;
  showError?: boolean;
  config?: QueryConfig<QueryFnType>;
};

export const useGetLibraryItem = ({
  libraryItemId,
  config,
  showError = false,
}: UseGetLibraryItemOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [...getLibraryItemQueryKey.list, libraryItemId, showError],
    queryFn: () => getLibraryItem({ libraryItemId, showError }),
    // staleTime: Infinity,
    cacheTime: 0,
    ...config,
  });
};
